export default "__VITE_ASSET__89ccf1bc__"